import { FunctionComponent } from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";

export interface ITextMarkdownProps {
  children: string;
  className?: string;
}

export const TextMarkdown: FunctionComponent<ITextMarkdownProps> = (props: ITextMarkdownProps) => {
  return (
    <div className={props.className}>
      <ReactMarkdown remarkPlugins={[remarkBreaks]}>{props.children}</ReactMarkdown>
    </div>
  );
};
